import { Component, input } from '@angular/core';
import { Icon } from './../icon/icon';
import { CssColor } from '@appTypes';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [Icon],
  templateUrl: './logo.html',
  styles: `
    :host {
      display: flex;
    }
  `,
})
export class Logo {
  // Inputs
  $brand = input<'seekop' | 'gm' | 'kia', string>('seekop', { alias: 'brand',
    transform: value => {
      value = value.trim().toLowerCase();

      if (/gm/.test(value))
        return 'gm';

      if (/kia/.test(value))
        return 'kia';

      return 'seekop';
    } });
  $scale = input<number>(1, { alias: 'scale' });
}
